import Vue from 'vue';
import {componentFactory} from 'vue-class-component/lib/component';
import {Order} from "@/domain/Order";
import store from '@/store'

export enum Messages {
    tradeOrderWindowShow= 'tradeOrderWindowShow',
    tradeOrderWindowClose= 'tradeOrderWindowClose',
    selectSymbol = 'selectSymbol',
    // error= 'error',
    // login= 'login',
    // logout= 'logout',
    selectExpiration= 'selectExpiration',
    selectStrike= 'selectStrike',
    TradingBlockAjaxError= 'TbAjaxError',
    TabChanged= 'TabChanged',
    GenericRefresh= 'refresh',
    BalanceRefresh= 'balanceRefresh',
    AccountWithSubChange= 'accountChange',
    DragPlaceWindowDisable = 'dragDisable',
    DragPlaceWindowEnable = 'dragEnable',
}

export enum OrderMessages {
    OrdersRefresh= 'ordersRefresh',
    OrdersSearch= 'ordersSearch',
    OrderTableClick= 'orderTableClick',
    OrdersLoaded= 'ordersLoaded',
    OrdersEditPrice= 'orderEditPrice',
    OrdersEditPriceSuccess= 'orderEditPriceSuccess',
    OrderCancelSuccess = 'orderCancelSuccess',
    OrderAdded = 'orderAdded',
    // test helpers
}

export const enum PositionMessages {
    PositionRefresh= 'positionRefresh',
    PositionsLoaded= 'positionsLoaded', // test helpers
    PositionTableClick= 'positionsTableClick',
}

export const EventBus = new Vue({
    data() {
        return {
            companySymbol: '',
        };
    },
    methods: {
        async showTradeForm(order: Order) {
            await store.dispatch('SHOW_TRADE_WINDOW', order);
            this.$emit(Messages.tradeOrderWindowShow, order);
        },
        setUnderlying(symbol: string) {
            store.dispatch('selectSymbol', symbol);
            this.$emit(Messages.selectSymbol, this.companySymbol);
        },

    },
});
//
// declare var EventBus : {
//     setUnderlying(symbol: string):void,
//     getUnderlying():string
// }
// EventBus.setUnderlying = (symbol: string) => {
//     EventBus.companySymbol = symbol;
//     EventBus.$emit(Messages.selectSymbol, EventBus.companySymbol)
// };
// EventBus.getUnderlying = ()=>{
//     if (EventBus.companySymbol) { return EventBus.companySymbol; }
//     return companySymbol;
// };

export const OrderBus = new Vue();
export const PositionBus = new Vue();
